module.exports = __webpack_public_path__ + "img/payType.40dc935.png";